export const sanAntonioLatLng = {
  lat: 29.4241,
  lng: -98.4936
}

export const panMapBounds = (
  map: google.maps.Map | undefined,
  latLngs: google.maps.LatLng[],
  padding: google.maps.Padding = { top: 0, bottom: 0, left: 0, right: 0 }
) => {
  if (!map) return
  const bounds = new google.maps.LatLngBounds()
  for (const latLng of latLngs) {
    if (!latLng) continue
    bounds.extend(latLng)
  }
  map.fitBounds(bounds, padding)
  map.panToBounds(bounds)
}
